import { InvisibleReCaptcha2Button } from '@rcm/recaptcha-2';
import { SelectField } from 'forms';
import LoadingSpinner from 'loading-spinner/LoadingSpinner';
import t from 'rcm-i18n';
import React from 'react';
import { EVENT_REGISTRATION } from '@rcm/event-registration';

interface Props {
  displayState: string;
  formData: { email: string; firstName: string; lastName: string; countryIso3: string };
  countryList: { value: string; label: string }[];
  handleFormInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleCaptchaChange: (newValue: string) => void;
  handleFormSubmit: (e: React.FormEvent) => void;
  handleRegisterAnotherClick: () => void;
}

const RegistrationForm = ({
  displayState,
  handleFormSubmit,
  formData,
  countryList,
  handleFormInputChange,
  handleCaptchaChange,
  handleRegisterAnotherClick,
}: Props) => {
  const translatedCountryList = countryList.map((country) => ({ value: country.value, label: t(country.label) }));
  return (
    <div>
      {displayState === 'loading' && (
        <div>
          <LoadingSpinner />
        </div>
      )}
      {displayState === 'errorNotLoggedIn' && (
        <div className="alert alert-warning">{t('You must be logged in before you can register for events.')}</div>
      )}
      {displayState === 'errorMissingEventId' && (
        <div className="alert alert-warning">
          <h1>Free Simple Event Registration Block</h1>
          Event ID is missing. A CMS admin can fix this by editing this block's properties.
        </div>
      )}
      {['formReady', 'errorCommunicatingWithServer', 'errorFormDataIsInvalid'].includes(displayState) && (
        <form onSubmit={handleFormSubmit}>
          {displayState === 'errorCommunicatingWithServer' && (
            <div className="alert alert-warning">
              {/* We need to flip this back once we regain the ability to return response codes other than 404. */}
              {t('Some information was missing or invalid on the form.' + ' Please check the form and try again.')}
              {/* {t('An error occurred while communicating with servers.'
                            + ' Please ensure you are logged in and connected to the internet.'
                            + ' Then try again.')} */}
            </div>
          )}
          {displayState === 'errorFormDataIsInvalid' && (
            <div className="alert alert-warning">
              {t('Some information was missing or invalid on the form.' + ' Please check the form and try again.')}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="freeSimpleEventRegistrationFirstName">{t('First Name')}</label>
            <input
              type="text"
              className="form-control"
              id="freeSimpleEventRegistrationFirstName"
              value={formData.firstName}
              onChange={handleFormInputChange}
              name="firstName"
            />
          </div>
          <div className="form-group">
            <label htmlFor="freeSimpleEventRegistrationLastName">{t('Last Name')}</label>
            <input
              type="text"
              className="form-control"
              id="freeSimpleEventRegistrationLastName"
              value={formData.lastName}
              onChange={handleFormInputChange}
              name="lastName"
            />
          </div>
          <div className="form-group">
            <label htmlFor="freeSimpleEventRegistrationEmail">{t('Email Address')}</label>
            <input
              type="email"
              className="form-control"
              id="freeSimpleEventRegistrationEmail"
              value={formData.email}
              onChange={handleFormInputChange}
              name="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="freeSimpleEventRegistrationCountry">{t('Country')}</label>
            <SelectField
              options={translatedCountryList}
              id="freeSimpleEventRegistrationCountry"
              value={formData.countryIso3}
              onChange={handleFormInputChange}
              name="countryIso3"
            />
          </div>
          <div className="clearfix"></div>
          <div>
            <InvisibleReCaptcha2Button
              action={EVENT_REGISTRATION}
              type="submit"
              btn="primary"
              className="pull-right"
              onValueChange={handleCaptchaChange}
              text={t('Register for this event')}
            />
          </div>
          <div className="clearfix"></div>
        </form>
      )}
      {displayState === 'registeredSuccessFully' && (
        <>
          <div className="alert alert-success">
            {t(
              '{firstName} {lastName} has been successfully registered for this event' +
                ' and will receive an email with more details at {email}',
              formData
            )}
          </div>
          <button type="button" className="btn btn-primary pull-right" onClick={handleRegisterAnotherClick}>
            {t('Register another person for this event')}
          </button>
        </>
      )}
    </div>
  );
};

export default RegistrationForm;
